import { language_enum, org_sector_type_enum, org_status_type_enum, org_type_enum, role_enum } from '@predium/enums';
import * as yup from 'yup';
import { yupNativeEnum } from '@/utils/extendedYup/yupCustomMethods';

/** Mirrors the SessionData shape from Auth0 */
export const sessionDataSchema = yup.object({
  user: yup.object({
    id: yup.number().required(),
    createdAt: yup.date().required(),
    email: yup.string().email().required(),
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    language: yupNativeEnum(language_enum).required(),
    roleDescription: yup.string().default(''),
    isActive: yup.boolean().required(),
    role: yupNativeEnum(role_enum).required(),
  }),
  org: yup.object({
    id: yup.number().required(),
    name: yup.string().required(),
    statusTypeId: yupNativeEnum(org_status_type_enum).required(),
    orgTypeId: yupNativeEnum(org_type_enum).required(),
    orgSector: yupNativeEnum(org_sector_type_enum).required(),
    logoUrl: yup.string().nullable(true).optional(),
    userLogoutIdleTimeout: yup.number().nullable(true).optional(),
    isEconomicUnitsToggled: yup.boolean().required(),
  }),
  enabledFeatureFlags: yup.array().of(yup.string().required()).required(),
  isAdmin: yup.boolean().required(),
  firstBuildingId: yup.number().nullable(true).optional(),
  hasPortfolioWithWriteAccess: yup.boolean().required(),
});
